import styled from '@emotion/styled';
import { Button, PasswordInput, TextInput } from '@mantine/core';

import { mediaQueryMobile } from '~/styles/mixins';

import { Default14px, Default16px } from '../../typography/baseDefinitions';

export const ContinueWithGoogleBtn = styled(Button)`
  border: 1px solid #d1d1d1;

  ${mediaQueryMobile} {
    height: 40px;
  }
  div {
    color: #616161;
  }

  &:hover {
    background-color: transparent;
  }
`;

ContinueWithGoogleBtn.defaultProps = {
  variant: 'outline',
  radius: 'xl',
  size: 'lg',
};

export const FormTextInput = styled(TextInput)`
  input {
    height: 48px;
    margin-top: 4px;
    ${Default16px};
    color: #616161;
    ${mediaQueryMobile} {
      height: 40px;
      min-height: 40px;
      ${Default14px};
    }
  }
`;

FormTextInput.defaultProps = {
  size: 'lg',
  variant: 'filled',
  styles: { error: { fontSize: '14px' } },
};

export const FormPasswordInput = styled(PasswordInput)`
  margin-top: 4px;

  input {
    height: 48px;
    ${Default16px};
    color: #616161;
  }

  ${mediaQueryMobile} {
    > div > div {
      height: 40px;
      min-height: 40px;
    }
    input {
      ${Default14px};
      height: 40px;
    }
  }
`;

FormPasswordInput.defaultProps = {
  size: 'lg',
  variant: 'filled',
  styles: { error: { fontSize: '14px' } },
};

export const PrimaryBtn = styled(Button)`
  background-color: #222;

  &:hover {
    background-color: #222;
  }
  ${mediaQueryMobile} {
    height: 40px;
  }
`;

PrimaryBtn.defaultProps = {
  variant: 'filled',
  radius: 'xl',
  size: 'lg',
};

export const OutlinedBtn = styled(Button)`
  border: 1px solid #222222;
  ${mediaQueryMobile} {
    height: 40px;
  }
`;

OutlinedBtn.defaultProps = {
  variant: 'outline',
  radius: 'xl',
  size: 'lg',
};
